import { render, staticRenderFns } from "./wx-notice.vue?vue&type=template&id=07423352&scoped=true&"
import script from "./wx-notice.vue?vue&type=script&lang=js&"
export * from "./wx-notice.vue?vue&type=script&lang=js&"
import style0 from "./wx-notice.vue?vue&type=style&index=0&id=07423352&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07423352",
  null
  
)

export default component.exports